import { Input } from "src/designsystem/Input/Input";

import { InputRef } from "antd";
import { ForwardedRef, forwardRef } from "react";
import { useController } from "react-hook-form";
import { FormInputProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";

export const FormInput = forwardRef((props: FormInputProps, ref: ForwardedRef<InputRef>) => {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <Input {...childProps} {...field} ref={ref} />
    </FormField>
  );
});
